import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { queryKey } from '../../../constant/queryKey';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { cartService } from 'shared/src/api';

export const usePreloadGoodsRecommend = () => {
  const client = useQueryClient();

  const goodsSno = useGoodsSno();

  return useCallback(() => {
    client.prefetchQuery({
      queryKey: queryKey.goodsLikeRecommend(goodsSno, 'like'),
      queryFn: () => cartService.getAddCartRecommend(goodsSno),
    });
  }, [client, goodsSno]);
};
